import script from "./LogoutBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoutBtn.vue?vue&type=script&setup=true&lang=js"

import "./LogoutBtn.vue?vue&type=style&index=0&id=66f4ca74&lang=scss"

const __exports__ = script;

export default __exports__